module.exports = __webpack_public_path__ + "static/media/thumbnail_alex.8873fb8d.jpg";